module.exports = __webpack_public_path__ + "img/v12.066033df.jpg";